import { Link } from "react-router-dom" 

const Button = ({call, link}) => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    return (
        <div className='w-max cursor-pointer grow' onClick={() => scrollToTop()}>
            <Link to={link}>
                <button className='w-max mx-auto bg-accent rounded-md px-6 py-2 text-white'>{call}</button>
            </Link>
        </div>
    )
}

export default Button